import React, { useState } from 'react';
import { cmp } from '@guardian/consent-management-platform';
import { canShow as canShowRRBanner, ReaderRevenueBanner, } from '@root/src/web/components/StickyBottomBanner/ReaderRevenueBanner';
import { getAlreadyVisitedCount } from '@root/src/web/lib/alreadyVisited';
import { useOnce } from '@root/src/web/lib/useOnce';
import { pickBanner } from './bannerPicker';
import { BrazeBanner, canShow as canShowBrazeBanner } from './BrazeBanner';
const getBannerLastClosedAt = (key) => {
    const item = JSON.parse(localStorage.getItem(`gu.prefs.${key}`) || '');
    return item.value;
};
const DEFAULT_BANNER_TIMEOUT_MILLIS = 2000;
const buildCmpBannerConfig = () => ({
    id: 'cmpUi',
    canShow: () => cmp.willShowPrivacyMessage().then((result) => ({ result: !!result })),
    show: () => {
        // New CMP is not a react component and is shown outside of react's world
        // so render nothing if it will show
        return null;
    },
    timeoutMillis: null,
});
const buildReaderRevenueBannerConfig = (CAPI, isSignedIn, asyncCountryCode) => {
    return {
        id: 'reader-revenue-banner',
        canShow: () => canShowRRBanner({
            remoteBannerConfig: CAPI.config.remoteBanner,
            isSignedIn,
            asyncCountryCode,
            contentType: CAPI.contentType,
            sectionName: CAPI.sectionName,
            shouldHideReaderRevenue: CAPI.shouldHideReaderRevenue,
            isMinuteArticle: CAPI.pageType.isMinuteArticle,
            isPaidContent: CAPI.pageType.isPaidContent,
            isSensitive: CAPI.config.isSensitive,
            tags: CAPI.tags,
            contributionsServiceUrl: CAPI.contributionsServiceUrl,
            alreadyVisitedCount: getAlreadyVisitedCount(),
            engagementBannerLastClosedAt: getBannerLastClosedAt('engagementBannerLastClosedAt'),
            subscriptionBannerLastClosedAt: getBannerLastClosedAt('subscriptionBannerLastClosedAt'),
        }),
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        show: (meta) => () => React.createElement(ReaderRevenueBanner, Object.assign({}, meta)),
        timeoutMillis: DEFAULT_BANNER_TIMEOUT_MILLIS,
    };
};
const buildBrazeBanner = (isSignedIn, idApiUrl) => ({
    id: 'braze-banner',
    canShow: () => canShowBrazeBanner(isSignedIn, idApiUrl),
    show: (meta) => () => React.createElement(BrazeBanner, { meta: meta }),
    timeoutMillis: DEFAULT_BANNER_TIMEOUT_MILLIS,
});
export const StickyBottomBanner = ({ isSignedIn, asyncCountryCode, CAPI, idApiUrl, }) => {
    const [SelectedBanner, setSelectedBanner] = useState(null);
    useOnce(() => {
        const CMP = buildCmpBannerConfig();
        const readerRevenue = buildReaderRevenueBannerConfig(CAPI, isSignedIn, asyncCountryCode);
        const brazeBanner = buildBrazeBanner(isSignedIn, idApiUrl);
        const bannerConfig = [CMP, readerRevenue, brazeBanner];
        pickBanner(bannerConfig).then((PickedBanner) => setSelectedBanner(PickedBanner));
    }, [isSignedIn, asyncCountryCode, CAPI]);
    if (SelectedBanner) {
        return React.createElement(SelectedBanner, null);
    }
    return null;
};
